export default __webpack_public_path__ + "a317ce76e314c59f9b4ffb72ac4c559e.png";